import React from 'react';
import { Helmet } from 'react-helmet';

const BlogPostSchema = ({ title, description, datePublished, author, imageUrl, url }) => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    "headline": title,
    "description": description,
    "image": imageUrl || "https://quick-inbox.com/logo.png",
    "datePublished": datePublished,
    "author": {
      "@type": "Person",
      "name": author || "Quick Inbox Team"
    },
    "publisher": {
      "@type": "Organization",
      "name": "Quick Inbox",
      "logo": {
        "@type": "ImageObject",
        "url": "https://quick-inbox.com/logo.png"
      }
    },
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": url || "https://quick-inbox.com"
    }
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
};

export default BlogPostSchema; 